import CustomDrawer from "../shared/CustomDrawer";
import { useRequest } from "../../api/utils/useRequest";
import { BalootUserAPIs } from "../../api/APIs";
import { useEffect, useState } from "react";
import { ibanToBank, removeNonNumeric } from "../../utils/Utils";
import { Box, Button, IconButton, TextField, Typography } from "@mui/material";
import { CacheProvider } from "@emotion/react";
import createCache from "@emotion/cache";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import InputAdornment from "@mui/material/InputAdornment";
import { LoadingButton } from "@mui/lab";

const cacheltr = createCache({
  key: "muiltr",
  stylisPlugins: [],
});

export function CashoutBottomSheet(props) {
  const { open, setOpen, iban, banks, setIban } = props;
  const { loading, apiCall: updateIban } = useRequest(
    BalootUserAPIs.updateIban
  );

  const [editedIban, setEditedIban] = useState(iban || "");
  const [bank, setBank] = useState(ibanToBank(editedIban, banks));

  useEffect(() => {
    if (editedIban.length >= 3 && editedIban.length <= 5) {
      setBank(ibanToBank(editedIban, banks));
    }
  }, [editedIban]);

  useEffect(() => {
    setEditedIban(iban || "");
    setBank(ibanToBank(iban || "", banks));
  }, [iban]);

  const onSubmit = () => {
    updateIban({
      data: { iban: `IR${editedIban}` },
      onSuccess: () => {
        setIban(editedIban);
        setOpen(false);
      },
    });
  };

  return (
    <CustomDrawer
      open={open}
      onClose={() => {
        setEditedIban(iban || "");
        setBank(ibanToBank(iban || "", banks));
        setOpen(false);
      }}
    >
      <Box
        sx={{ display: "flex", alignItems: "center", flexDirection: "column" }}
      >
        <Box width={44} height={44}>
          {bank ? <img width={44} height={44} src={bank.logoUrl} /> : <></>}
        </Box>
        <Typography mt={1} variant="subtitle1" color="grey.2">
          {bank?.name}
        </Typography>
      </Box>
      <Typography mt={1} variant="body2" color="grey.2">
        شماره شبا
      </Typography>
      <CacheProvider value={cacheltr}>
        <TextField
          error={editedIban.length === 24 && !bank}
          inputProps={{
            inputMode: "numeric",
          }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <Box sx={{ display: "flex", alignItems: "center" }}>
                  {editedIban.length > 0 && (
                    <IconButton
                      onClick={() => {
                        setEditedIban("");
                        setBank(null);
                      }}
                    >
                      <CancelOutlinedIcon sx={{ fontSize: 20 }} />
                    </IconButton>
                  )}
                  <Typography mr={1} mt={"4px"}>
                    IR |{" "}
                  </Typography>
                </Box>
              </InputAdornment>
            ),
          }}
          value={editedIban}
          onChange={(event) => {
            if (event.target.value === null) {
              setEditedIban("");
            } else {
              event.target.value.length < 25 &&
                setEditedIban(removeNonNumeric(event.target.value));
            }
          }}
          sx={{ mt: "12px", direction: "ltr" }}
          fullWidth
        />
      </CacheProvider>
      <LoadingButton
        onClick={onSubmit}
        loading={loading}
        disabled={
          editedIban.length < 24 ||
          editedIban === iban ||
          (editedIban.length === 24 && !bank)
        }
        sx={{
          mt: 2,
          color: "common.white",
          typography: "h3",
        }}
        variant="contained"
        fullWidth
      >
        ثبت
      </LoadingButton>
    </CustomDrawer>
  );
}
